import React from 'react';
import { Sparkles } from 'lucide-react';
import { Badge } from '../../../../ui/badge';

interface ThinkingBlockProps {
  status?: string | null;
  progressMessage?: string | null;
  activatedSkills?: string[] | null;
}

const ThinkingBlock: React.FC<ThinkingBlockProps> = ({ status, progressMessage, activatedSkills }) => {
  const latestSkill = activatedSkills?.[activatedSkills.length - 1];
  const isLowLevelActivity =
    !!progressMessage &&
    /loading skill instructions|fetching attached evidence|loaded \d+ evidence documents|fetching complaint signal details|searching .* database|gettings? ml model prediction|loaded complaint signal/i.test(
      progressMessage
    );

  const displayMessage =
    (!isLowLevelActivity && progressMessage) ||
    status ||
    (latestSkill ? `Activated skill: ${latestSkill}` : 'Reviewing this complaint against precedent and internal context.');

  return (
    <div className="flex gap-3 p-4 bg-primary/5 rounded-xl">
      <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
        <Sparkles className="w-4 h-4 text-primary animate-pulse" />
      </div>
      <div className="flex-1">
        <div className="flex items-center gap-2">
          <p className="text-sm text-foreground font-medium">Thinking</p>
          <div className="flex gap-1">
            <span className="w-1.5 h-1.5 bg-primary rounded-full animate-bounce" />
            <span
              className="w-1.5 h-1.5 bg-primary rounded-full animate-bounce"
              style={{ animationDelay: '0.1s' }}
            />
            <span
              className="w-1.5 h-1.5 bg-primary rounded-full animate-bounce"
              style={{ animationDelay: '0.2s' }}
            />
          </div>
        </div>
        <p className="text-sm text-muted-foreground mt-1">{displayMessage}</p>
        {activatedSkills && activatedSkills.length > 0 && (
          <div className="flex items-center gap-1.5 mt-2 flex-wrap">
            <span className="text-xs text-muted-foreground">Skills:</span>
            {activatedSkills.map((skill: string) => (
              <Badge
                key={skill}
                variant="outline"
                className="text-[10px] px-1.5 py-0 h-5 text-primary/70 border-primary/20 bg-primary/5"
              >
                {skill}
              </Badge>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ThinkingBlock;
